import script from "./AutoGenerateHintSection.vue?vue&type=script&setup=true&lang=ts"
export * from "./AutoGenerateHintSection.vue?vue&type=script&setup=true&lang=ts"

import "./AutoGenerateHintSection.vue?vue&type=style&index=0&id=6b6513fa&lang=scss&scoped=true"

import exportComponent from "../../../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-6b6513fa"]])

export default __exports__